var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
      'drag-and-drop': true,
      'drag-and-drop--hover': _vm.isHover
  },on:{"dragover":_vm.dragover,"dragleave":_vm.dragleave,"drop":_vm.drop}},[_c('input',{ref:"file",attrs:{"type":"file","multiple":"","accept":".jpg,.jpeg,.png"},on:{"change":_vm.onChange}}),_c('span',[_vm._v(_vm._s(_vm.placeholder))])])}
var staticRenderFns = []

export { render, staticRenderFns }